import styled from 'styled-components'

export const Container = styled.div`
  margin-top: ${props => props.theme.spacing.sp16};

  button {
    width: fit-content;
  }
`
